import { InsuranceType, PayerMixReportDateType } from "../../Enums/ChoiceEnums";

export const PayerMixDateTypes: { dateType: PayerMixReportDateType, name: string } [] = [
    { dateType: PayerMixReportDateType.ServiceDate,  name: "Service Date" },
    { dateType: PayerMixReportDateType.ServicePostDate, name: "Service Post Date"},
    { dateType: PayerMixReportDateType.DepositDate, name: "Deposit Date"},
    { dateType: PayerMixReportDateType.DepositPostDate, name: "Deposit Post Date"}
];

export const PayerMixInsuranceTypes: {insuranceType: InsuranceType, name: string}[] = [
    { insuranceType: InsuranceType.Primary, name: "Primary" },
    { insuranceType: InsuranceType.Secondary, name: "Secondary" },
    { insuranceType: InsuranceType.Tertiary, name: "Tertiary" }    
];